export default __webpack_public_path__ + "static/media/removeItem.e6226782.svg";